import React from 'react'
import {H2, H3, H4, H5, H6} from '@modifi/ui'
import {Picture} from '@modifi/website-client'

import {StyledP, Anchor} from './styles'

export const componentMap = {
  h1: <H2 as="h1" mt={48} mb={24} />,
  h2: <H3 as="h2" mt={48} mb={24} />,
  h3: <H3 mt={40} mb={28} />,
  h4: <H4 mt={40} mb={24} />,
  h5: <H5 mt={40} mb={24} />,
  h6: <H6 mt={40} mb={16} />,
  span: <span />,
  a: <Anchor target="_blank" rel="noopener noreferrer" />,
  img: <Picture objectFit="fill" />,
  li: <li />,
  ul: <ul />,
  ol: <ol />,
  p: <StyledP />,
  figure: <figure />,
  figcaption: <figcaption />,
  b: <b />,
  i: <i />,
  em: <em />,
}
